import { FC, RefObject } from 'react';
import { Popover } from '@mui/material';
import { DateCalendar } from '@mui/x-date-pickers';
import {
  jsDateToPickerValue,
  pickerValueToJsDate,
} from '../../../../../components/new-design/date-picker/picker-value-utils';

type DatePickerPopoverProps = {
  open: boolean;
  anchorEl: RefObject<HTMLButtonElement>;
  selectedDate: Date | null;
  contractEndDate: Date;
  onClose: () => void;
  onChange: (date: Date | null) => void;
};

export const DatePickerPopover: FC<DatePickerPopoverProps> = ({
  open,
  anchorEl,
  selectedDate,
  onClose,
  contractEndDate,
  onChange,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl.current}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <DateCalendar
        value={jsDateToPickerValue(selectedDate)}
        minDate={jsDateToPickerValue(contractEndDate)?.add(1, 'day') ?? undefined}
        shouldDisableDate={(date) => {
          const contractEnd = jsDateToPickerValue(contractEndDate);
          return contractEnd ? date.isSameOrBefore(contractEnd, 'day') : false;
        }}
        onChange={(newDate) => onChange(pickerValueToJsDate(newDate))}
      />
    </Popover>
  );
};
